export const IntegrationsMessages: { [key:string]: string | undefined } = {
    adc: "Link your Deako home to your Alarm.com account",
    alexa: "Link your Deako home to your Alexa.",
    googlehome: "Link your Deako home to your Google Home.",
    smartthings_schema: "Link your Deako home to SmartThings.",
    unsupported: "app is not supported integration",
    smartthings: "Link your Deako home to SmartThings.",
};

export const WelcomeText = {
    login: "Log In/Sign Up",
};

export const ProfileSelectionText = {
    title: "Choose home",
    desc: (integration: string) => `Select the location that you would like to connect your ${integration}.`,
};
